// extracted by mini-css-extract-plugin
export var title = "styles-module--title--Ja-UJ";
export var section = "styles-module--section--i4uK2";
export var innerContainer = "styles-module--innerContainer--3oH_F";
export var image = "styles-module--image--1Z1Y9";
export var form = "styles-module--form--1OKmn";